/**
 * İçerik tipi listesini SEKMELER ARASI güncel tutan küçük yayın kanalı.
 *
 * Form detayı `window.open` ile ayrı bir sekmede açılıyor. Orada ad/kod
 * değiştirildiğinde liste sekmesi kendi durumunda eski değeri göstermeye devam
 * ediyordu; kullanıcı sayfayı yenilemek ya da menüden yeniden girmek zorunda
 * kalıyordu.
 *
 * Neden `BroadcastChannel`: liste sekmesi ARKA PLANDAYKEN de haberi alıyor, yani
 * kullanıcı geri döndüğünde ekran zaten doğru. Yalnız "sekmeye dönünce tazele"
 * kuralına güvenmek, sekme değişiminin odak olayı üretmediği (gömülü tarayıcı,
 * yan yana pencere) durumlarda sessizce çalışmıyordu — ikisi birlikte duruyor.
 *
 * Mesaj İÇERİK TAŞIMAZ: "bir şey değişti" demek yeter, alıcı zaten listeyi
 * sunucudan tazeliyor. Kısmi veriyi sekmeler arasında taşımak iki ayrı gerçek
 * kaynak üretirdi.
 */
const KANAL = "audex:icerik-tipleri"

/** Kanal desteklenmiyorsa (eski tarayıcı, test ortamı) sessizce yok sayılır. */
function kanal(): BroadcastChannel | null {
  try {
    return typeof BroadcastChannel === "undefined" ? null : new BroadcastChannel(KANAL)
  } catch {
    return null
  }
}

/** Bir içerik tipi yazıldı — öteki sekmeler listelerini tazelesin. */
export function icerikTipiDegisti(): void {
  const ch = kanal()
  if (!ch) return
  try {
    ch.postMessage("degisti")
  } finally {
    ch.close()
  }
}

/**
 * Değişiklik bildirimlerini dinler; aboneliği bırakan fonksiyonu döndürür.
 * Kendi gönderdiği mesajı almaz (BroadcastChannel kuralı) — gönderen sekme
 * zaten kendi durumunu güncelliyor.
 */
export function icerikTipiDinle(fn: () => void): () => void {
  const ch = kanal()
  if (!ch) return () => {}
  ch.onmessage = () => fn()
  return () => ch.close()
}
